import { httpClient } from "../http/httpClient";
import { Lead } from "@/app/entities/Lead";

export interface LeadResponse {
  leads: Lead[];
  pagination: {
    limit: number;
    skip: number;
    sort: string;
    order: string;
    total: number;
  };
}

export interface LeadParams {
  search?: string;
  limit?: number;
  skip?: number;
  sort?: string;
  order?: string;
}

export async function getLeads(params?: LeadParams) {
  const { data } = await httpClient.get<LeadResponse>("/lead", {
    params,
  });

  return data;
}
